module.exports = __webpack_public_path__ + "img/vcf_icm.1dee8d21.png";